import { createAsyncThunk } from '@reduxjs/toolkit';
import { RelationEntity } from '@interpals/api-web';

import api from 'api';
import { ReduxState } from 'redux/root-reducer';

export const PAGE_LIMIT = 10;

export const getBlockedUsers = createAsyncThunk<RelationEntity[], void, { state: ReduxState }>(
    'get/blocked',
    async (_, { getState }) => {
        const { blocked } = getState();
        const offset = blocked.data.length;

        return (await api.getRelationByType({ id: 'self', type: 'blocked', limit: PAGE_LIMIT, offset })).data;
    },
);

export const getBlockedUsersCount = createAsyncThunk('get/blocked-count', async () => {
    return await api.getUserBlockedCount({ id: 'self' });
});
